import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import howItWorks from '../../logos/how-it-works.svg';
import ourCustomers from '../../logos/our-customers.svg';
// import member from '../../logos/member.svg';
// import calendar from '../../logos/calendar.svg';

import './Messenger.scss';

import nbcLogo from '../../logos/nbc.png';
import abcLogo from '../../logos/abc.png';
import cbsLogo from '../../logos/cbs.png';
import foxLogo from '../../logos/fox.png';
import cnnLogo from '../../logos/CNN.png';
import hilton from '../../logos/hilton.png';
import edelman from '../../logos/edelman.png';
import microsoft from '../../logos/microsoft.png';
import intuit from '../../logos/intuit.png';
import hp from '../../logos/hp.png';
import ap from '../../logos/ap.png';
import wsj from '../../logos/wsj.png';
import people from '../../logos/people.png';
import wp from '../../logos/wp.png';
import nprLogo from '../../logos/npr.png';
import conagra from '../../logos/conagra.png';
// import burson from "../../logos/burson.png";
import twitter from '../../logos/twitter-x.png';
import bilt from '../../logos/bilt.png';
import perdue from '../../logos/perdue.png';
import goya from '../../logos/goya.png';
// import newsCorp from "../../logos/newscorp.webp";

import classNames from 'classnames';
import Input from '../Input/Input';
import Dropdown from '../Dropdown/Dropdown';

import { validateEmail, validateName } from '../../utils/utils';

import { callSignUp } from '../../Apis/actions/signin-actions';

import { postBio } from '../../Apis/actions/signin-actions';

import useDetectDevice from '../../functionality/Hooks/detectDevice';

import posthog from 'posthog-js';

const Messenger = () => {
  const dispatch = useDispatch();

  const { signUpLoading, signUpSuccess, signUpError, errorCode, postBioLoading } = useSelector(
    (state) => state.signInReducer
  );

  const [email, setEmail] = useState('');

  const [name, setName] = useState('');
  const [selectedDomain, setSelectedDomain] = useState('');

  const [isNewsroomRes, setIsNewsroomRes] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');

  const [isAutoAdded, setIsAutoAdded] = useState(false);

  const [domainArr, setDomainArr] = useState([
    { name: 'a@news.com', value: 'a@news.com' },
    { name: 'b@news.com', value: 'b@news.com' },
    { name: 'c@news.com', value: 'c@news.com' }
  ]);
  const [currentStage, setCurrentStage] = useState('EMAIL');

  const [verificationType, setVerificationType] = useState(0);

  //verificationType// 0 or 1 - no permission for search
  //verificationType// 2 - Yes permission for search

  const [successOrErrorMessage, setSuccessOrErrorMessage] = useState('');

  const [selectedTab, setSelectedTab] = useState('');

  const isMobile = useDetectDevice(520);

  function handleEmailChange(e) {
    setEmail(e.target.value);
  }

  function handleNameChange(e) {
    setName(e.target.value);
  }

  function handleDomainSelect(domainData) {
    // console.log(domainData);
    setSelectedDomain(domainData?.id);
    setVerificationType(domainData?.verification_type);
  }

  function handleStartNow() {
    setCurrentStage('NAME');
  }

  useEffect(() => {
    if (domainArr.length === 1 && currentStage === 'DROPDOWN') {
      setSelectedDomain(domainArr[0].id);
      setVerificationType(domainArr[0].verification_type);
    }
  }, [currentStage, domainArr.length, domainArr]);

  const onSubmitCallback = useCallback(() => {
    posthog.identify(email);
    dispatch(callSignUp(email, handleStartNow, setSuccessOrErrorMessage));
  }, [dispatch, email]);

  const finalApiCall = (
    isEmailPresent,
    isDomainIdPresent,
    isNewsroom,
    setIsLoading,
    name,
    isAutoAdded
  ) => {
    dispatch(
      postBio(
        isEmailPresent,
        '',
        isDomainIdPresent,
        isNewsroom,
        setIsLoading,
        name.split(' ')[0],
        name.split(' ').length > 2
          ? name.split(' ')[1] + ' ' + name.split(' ')[2]
          : name.split(' ')[1],
        verificationType,
        setSuccessOrErrorMessage,
        setCurrentStage,
        setEmail
      )
    );
  };

  async function handleVerify() {
    const url = 'https://vajrozyb08.execute-api.us-west-2.amazonaws.com/dev/messenger-signup';
    try {
      setIsLoading(true);
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          type: 'INITIAL',
          email: email,
          first_name: name.split(' ')[0],
          last_name:
            name.split(' ').length > 2
              ? name.split(' ')[1] + ' ' + name.split(' ')[2]
              : name.split(' ')[1]
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const domainData = await response.json();
      // console.log(domainData);
      if (domainData?.success) {
        posthog.capture('Signup halfway', {
          verification_type: 0,
          first_name: name.split(' ')[0],
          last_name:
            name.split(' ').length > 2
              ? name.split(' ')[1] + ' ' + name.split(' ')[2]
              : name.split(' ')[1],
          domain_id: null,
          email: email
        });
      }
      const isNewsroom = domainData.is_newsroom;
      setIsNewsroomRes(isNewsroom);
      const isUserExists = domainData.user_exists;
      // const isUserExists = true;
      // setVerificationType(domainData.verification_type);
      if (isUserExists) {
        setErrorMessage('This email is already on TMX Messenger.');
      } else if (domainData.auto_added === true) {
        setIsAutoAdded(domainData.auto_added);

        finalApiCall(
          email,
          domainData.auto_added_domain,
          isNewsroom,
          setIsLoading,
          name,
          isAutoAdded
        );

        // window.open(
        //   `https://signup.tmxmessenger.com/signup?email=${email}&domainID=${domainData.auto_added_domain}&isNewsroom=${isNewsroom}&name=${name}&isAutoAdded=${domainData.auto_added}`,
        //   "_self"
        // );
      } else if (domainData.domain_list && domainData?.domain_list.length === 0) {
        setVerificationType(0);
        setEmail('');
        setCurrentStage('EMAIL');
        setSuccessOrErrorMessage(
          <div className="tmx-messenger__errorMessage">
            Manual verification required. As we have sensitive information on our platform, we want
            to make sure you qualify for a login. We will be in touch within 24 hours.
          </div>
        );
        posthog.capture('Manual verification required', {
          verification_type: 0,
          first_name: name.split(' ')[0],
          last_name:
            name.split(' ').length > 2
              ? name.split(' ')[1] + ' ' + name.split(' ')[2]
              : name.split(' ')[1],
          domain_id: null,
          email: email
        });
      } else if (domainData.domain_list && domainData.domain_list.length > 0) {
        setCurrentStage('DROPDOWN');
        setDomainArr(domainData.domain_list);
      } else {
        // window.open(
        //   `https://signup.tmxmessenger.com/signup?email=${email}&domainID=null&isNewsroom=${isNewsroom}&name=${name}&isAutoAdded=${domainData.auto_added}`,
        //   '_self'
        // );
        // window.history.pushState(
        //   {},
        //   "",
        //   `signup?email=${email}&domainID=null&isNewsroom=${isNewsroom}`
        // );
      }

      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  function handleJoin() {
    finalApiCall(email, selectedDomain, isNewsroomRes, setIsLoading, name, isAutoAdded);

    // window.open(
    //   `https://signup.tmxmessenger.com/signup?email=${email}&domainID=${selectedDomain}&isNewsroom=${isNewsroomRes}&name=${name}&isAutoAdded=${isAutoAdded}`,
    //   "_self"
    // );
    // window.history.pushState(
    //   {},
    //   "",
    //   `signup?email=${email}&domainID=${selectedDomain}&isNewsroom=true`
    // );
  }

  const formattedSubject = 'Requesting permission to the use the Search Engine';

  const mailToLink = 'mailto:matt@usetmx.com?subject=' + encodeURIComponent(formattedSubject);

  const didNotRecieveLinkFormattedSubject = "I didn't receive my link to access TMX Search";

  const didNotRecieveLinkMailToLink =
    'mailto:matt@usetmx.com?subject=' + encodeURIComponent(didNotRecieveLinkFormattedSubject);

  const ComponentMapping = {
    EMAIL: (
      // <Input
      //   value={email}
      //   handleChange={handleEmailChange}
      //   placeholder={"Your work email address"}
      //   // placeholder={"Opens to public January 6, 2025"}
      //   // disabled={true}
      //   label={"Start Now"}
      //   handleClick={handleStartNow}
      //   validateFn={validateEmail}
      // />

      <Input
        value={email}
        handleChange={handleEmailChange}
        placeholder={'Enter your work email address'}
        handleClick={onSubmitCallback}
        disabled={signUpLoading}
        isLoading={signUpLoading}
        label={'Start'}
        validateFn={validateEmail}
      />
    ),
    NAME: (
      <div className="tmx-messenger__inputContainer">
        <Input
          value={name}
          handleChange={handleNameChange}
          placeholder={'Finally, your first and last name'}
          label={'Verify'}
          handleClick={handleVerify}
          validateFn={validateName}
          isLoading={isLoading}
        />
        {errorMessage && <div className="tmx-messenger__errorMessage">{errorMessage}</div>}
      </div>
    ),
    DROPDOWN: (
      <Dropdown
        value={selectedDomain}
        handleChange={handleDomainSelect}
        label={'Join'}
        handleClick={handleJoin}
        options={domainArr}
        isLoading={postBioLoading}
      />
    )
  };

  return (
    <div className="tmx-messenger">
      <div
        className={classNames('tmx-messenger__title', {
          'tmx-messenger__title--howItWorks': selectedTab === 'howItWorks' && isMobile
        })}>
        The best platform to find contacts.
      </div>

      {ComponentMapping[currentStage]}
      {signUpSuccess && (
        <div className="tmx-messenger__successMessage">
          Check your inbox <b>(or spam/junk)</b> for the link to access the TMX search engine. If
          you didn't receive the email, please{' '}
          <a className="tmx-messenger__successMessage" href={didNotRecieveLinkMailToLink}>
            Click here.
          </a>
        </div>
      )}
      {signUpError && errorCode === '401 Unauthorized: Not Verified Plus: NOT_IN_SYSTEM' && (
        <div className="tmx-messenger__errorMessage">
          You are currently not in our system.{' '}
          <a className="tmx-messenger__errorMessage" href="https://tmxmessenger.com/signup">
            Click here.
          </a>
        </div>
      )}

      {signUpError &&
        (errorCode === '401 Unauthorized: Not Verified Plus: VERIFIED' ||
          errorCode === '401 Unauthorized: Not Verified Plus: UNVERIFIED') && (
          <div className="tmx-messenger__errorMessage">
            You are in our system but need permission.{' '}
            <a className="tmx-messenger__errorMessage" href={mailToLink}>
              Click here.
            </a>
          </div>
        )}
      {successOrErrorMessage && successOrErrorMessage}

      <div
        className={classNames('tmx-messenger__chipsContainer', {
          'tmx-messenger__chipsContainer--visibilityHidden': currentStage === 'DROPDOWN'
        })}>
        <div
          onClick={() => setSelectedTab('howItWorks')}
          className={classNames('tmx-messenger__chips', {
            'tmx-messenger__chips--selected': selectedTab === 'howItWorks'
          })}>
          <img src={howItWorks} alt="how-it-works" className="tmx-messenger__chipsIcons" />
          <div>How it works</div>
        </div>
        <div
          onClick={() => setSelectedTab('ourCustomers')}
          className={classNames('tmx-messenger__chips', {
            'tmx-messenger__chips--selected': selectedTab === 'ourCustomers'
          })}>
          <img src={ourCustomers} alt="our-customers" className="tmx-messenger__chipsIcons" />
          <div>{isMobile ? 'Users' : 'Our users'}</div>
        </div>
        {/* <div
          onClick={() => setSelectedTab('member')}
          className={classNames('tmx-messenger__chips', {
            'tmx-messenger__chips--selected': selectedTab === 'member'
          })}>
          <img src={calendar} alt="our-customers" className="tmx-messenger__chipsIcons" />
          <div>{isMobile ? 'Demo' : 'Book a demo'}</div>
        </div> */}
      </div>

      <div
        className={classNames('tmx-messenger__content', {
          'tmx-messenger__content--visibilityHidden': currentStage === 'DROPDOWN'
        })}>
        {selectedTab === 'howItWorks' && (
          <>
            {/* <div className="tmx-messenger__content--title">How it works?</div> */}
            <div>
              TMX Search is being built by AI engineers and news executives dedicated to solving one
              problem. How do you make it ridiculously easy to find contacts for anyone you are
              trying to reach?
            </div>
            <ol>
              <li>
                When you enter a story link, our system will automatically provide you contacts of
                people connected to that story.
              </li>
              <li>
                When you enter a LinkedIn profile for anyone, our system will automatically provide
                you that person's contacts.
              </li>
              <li>
                When you enter a person's name, we can give you the contacts of all their relatives
                and addresses.
              </li>
              <li>
                When you describe what kind of expert you need, we will share options of who is
                available right now to comment or be booked.
              </li>
              <li>And anything else you can think of... it's like Google for contacts.</li>

              {/* <li>Then, search for any contact you need. Request any expert you want.</li> */}
              {/* <li>
                <span className="tmx-messenger__content--listTitle">
                  Send any message:{" "}
                </span>
                Email your message to{" "}
                <span className="tmx-messenger__content--link">
                  send@tmxmessenger.com
                </span>
                Send story ideas to journalists by emailing{' '}
                <a href="mailto:send@tmxmessenger.com" target="_blank" rel="noopener noreferrer">
                  send@tmxmessenger.com
                </a>
              </li> */}
              {/* <li>
                <span className="tmx-messenger__content--listTitle">
                  We forward it:{" "}
                </span>
                Our system sends your message to the right people. If you work
                in a PR firm/business, we forward your messages to the right
                people in the newsrooms. If you work in a newsroom, we forward
                your messages to the right people in PR firms/businesses.
              </li> */}
              {/* <li className="tmx-messenger__helptext">
                Any questions? Email{" "}
                <a
                  href="mailto:matt@usetmx.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  TMX Messenger support.
                </a>
              </li> */}
              {/* <li>If you need any contact, use the TMX search engine for contacts.</li> */}
            </ol>
            <div>
              We promise to ALWAYS have you covered. If the results aren't exactly what you want,
              our team will email you back the contacts you need.
            </div>
            {/* <ol>
              <li>
                <span className="tmx-messenger__content--listTitle">
                  Send a message:{" "}
                </span>
                Simply email{" "}
                <span className="tmx-messenger__content--link">
                  send@tmxmessenger.com
                </span>{" "}
                with your message.
              </li>
              <li>
                <span className="tmx-messenger__content--listTitle">
                  Smart forwarding:{" "}
                </span>
                The system automatically routes and forwards your message to the
                right people, no need to know specific names.
              </li>
              <li>
                <span className="tmx-messenger__content--listTitle">
                  Receive messages:{" "}
                </span>
                By using TMX messenger, you receive relevant messages our system
                forwards to you, ensuring you never miss opportunities.
              </li>
            </ol> */}
          </>
        )}
        {selectedTab === 'ourCustomers' && (
          <div className="tmx-messenger__logoMainContainer">
            <div className="tmx-messenger__logoContainer">
              <img src={nbcLogo} alt="nbcLogo" className="tmx-messenger__logoItem" />
              <img src={abcLogo} alt="abcLogo" className="tmx-messenger__logoItem" />
              <img src={cbsLogo} alt="cbsLogo" className="tmx-messenger__logoItem" />
              <img src={foxLogo} alt="foxLogo" className="tmx-messenger__logoItem" />
              <img src={cnnLogo} alt="cnnLogo" className="tmx-messenger__logoItem" />
            </div>
            <div className="tmx-messenger__logoContainer">
              <img src={hilton} alt="hilton" className="tmx-messenger__logoItem" />
              <img src={edelman} alt="edelman" className="tmx-messenger__logoItem" />
              <img src={microsoft} alt="microsoft" className="tmx-messenger__logoItem" />
              <img src={intuit} alt="intuit" className="tmx-messenger__logoItem" />
              <img src={hp} alt="hp" className="tmx-messenger__logoItem" />
            </div>
            <div className="tmx-messenger__logoContainer">
              <img src={ap} alt="apLogo" className="tmx-messenger__logoItem" />
              <img src={wsj} alt="wsj" className="tmx-messenger__logoItem" />
              <img src={people} alt="people" className="tmx-messenger__logoItem" />
              <img src={wp} alt="wp" className="tmx-messenger__logoItem" />
              <img src={nprLogo} alt="nprLogo" className="tmx-messenger__logoItem" />
            </div>
            <div className="tmx-messenger__logoContainer">
              <img src={conagra} alt="conagra" className="tmx-messenger__logoItem" />
              <img src={twitter} alt="twitter" className="tmx-messenger__logoItem" />
              <img src={bilt} alt="bilt" className="tmx-messenger__logoItem" />
              <img src={perdue} alt="perdue" className="tmx-messenger__logoItem" />
              <img src={goya} alt="goya" className="tmx-messenger__logoItem" />
            </div>
          </div>
        )}
        {selectedTab === 'member' && (
          <>
            {/* <div className="tmx-messenger__content--title">How it works?</div> */}
            <ol>
              <li>
                <a
                  href="https://calendly.com/mztmx/15-minute-sync?back=1&month=2025-06"
                  target="_blank"
                  rel="noopener noreferrer">
                  Book 15-min demo.
                </a>
              </li>
            </ol>
          </>
        )}
      </div>
    </div>
  );
};

export default Messenger;
